import React from "react";

/**
 * Public questionnaire renderers merged into project-o-react-fe.
 * Each is lazy-loaded so it stays out of the host's main bundle chunk.
 * See docs/superpowers/specs/2026-06-25-questionnaire-apps-integration-design.md
 */
export const BariApp = React.lazy(() => import("./BARI/BariApp"));
export const MiaApp = React.lazy(() => import("./MIA/MiaApp"));
export const FbApp = React.lazy(() => import("./FB-AD-CAMPAIGN/FbApp"));
